module.exports = __webpack_public_path__ + "static/media/loading.a902167c.gif";